module.exports = __webpack_public_path__ + "static/media/flag-ln.c9523df3.webp";